import { render, staticRenderFns } from "./FilterValueDateField.vue?vue&type=template&id=08060902&"
import script from "./FilterValueDateField.vue?vue&type=script&lang=js&"
export * from "./FilterValueDateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports